import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { artBoardActions } from '@store/reducers/artboard'
import { managerActions } from '@store/reducers/manager/actions'
import {
  activityHistoryActions,
  type PreviewSagaPayload,
} from '@store/reducers/manager/activityHistory/actions'
import { store } from '@store/store'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import axios, { type AxiosResponse } from 'axios'
import { call, put, select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

const fetchProjectSnapshot = (
  projectId: string,
  actionId: number
): Promise<AxiosResponse<any>> => {
  const token = localStorage.getItem('token')

  return axios.get(`/projects/${projectId}/${actionId}`, {
    baseURL: import.meta.env.VITE_SYNC_HTTP_URL,
    headers: {
      'X-Auth-Token': token,
    },
  })
}

export function* previewSaga(action: { payload: PreviewSagaPayload }) {
  try {
    const { id: actionId } = action.payload

    yield put({
      type: activityHistoryActions.setIsLoading.type,
    })

    yield put(artBoardActions.setActivityHistoryStatus({ status: true }))

    yield put({
      type: activityHistoryActions.setActivityHistorySetSelectedAction.type,
      payload: {
        id: actionId,
      },
    })

    // @ts-expect-error
    const projectId = yield select(migrationProjectSelector.getProjectId)

    // @ts-expect-error
    const snapshotResponse = yield call(
      fetchProjectSnapshot,
      projectId,
      actionId
    )

    const { data } = snapshotResponse

    yield put({
      type: managerActions.updateProjectAndRelations.type,
      payload: data,
    })

    yield put(
      notificationActionCreators.setNotification({
        type: NotificationType.ACTIVITY_HISTORY_PREVIEW,
        callback: () => {
          sendGtmEvent(GtmTriggerName.PROJECT_RESTORE)
          store.dispatch({
            type: activityHistoryActions.restoreSaga.type,
            payload: { id: actionId },
          })
        },
      })
    )
  } catch (error) {
    console.error('Error fetching project:', error)

    yield put({
      type: activityHistoryActions.setIsLoaded.type,
    })
  } finally {
    yield put({
      type: activityHistoryActions.setIsLoaded.type,
    })
  }
}
